(function () {
  function initGallery(root) {
    if (!root) return;
    var images = Array.from(root.querySelectorAll('[data-cp-image]'));
    var thumbs = Array.from(root.querySelectorAll('[data-cp-thumb]'));
    function show(i) {
      if (!images.length) return;
      var index = (i + images.length) % images.length;
      images.forEach(function (img, idx) {
        img.classList.toggle('is-active', idx === index);
      });
      thumbs.forEach(function (thumb, idx) {
        var active = idx === index;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        show(Number(thumb.dataset.index || 0));
      });
    });
    show(0);
  }

  function initCopyLink() {
    var btn = document.querySelector('[data-cp-copy-link]');
    if (!btn) return;
    var label = btn.querySelector('[data-cp-copy-label]');
    btn.addEventListener('click', function () {
      var url = window.location.href;
      var done = function () {
        if (!label) return;
        var prev = label.textContent;
        label.textContent = 'Copied';
        setTimeout(function () { label.textContent = prev; }, 1600);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done).catch(done);
      } else {
        done();
      }
    });
  }

  function initQuantity(form) {
    var input = form.querySelector('[data-qty-input]');
    var minus = form.querySelector('[data-qty-minus]');
    var plus = form.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) {
      minus.addEventListener('click', function () {
        input.value = String(Math.max(1, Number(input.value || 1) - 1));
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        input.value = String(Number(input.value || 1) + 1);
      });
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return '$' + (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function initVariants(form) {
    var jsonEl = document.querySelector('[data-product-json]');
    if (!jsonEl || !form) return;
    var product = JSON.parse(jsonEl.textContent);
    var variantInput = form.querySelector('[data-variant-id]');
    var priceEl = document.querySelector('.cp-price__current');
    var submitBtn = form.querySelector('[data-add-to-cart]');
    var submitText = form.querySelector('[data-add-to-cart-text]');
    var inventoryEl = document.querySelector('[data-cp-inventory-qty]');
    var currentId = Number(variantInput.value);
    var currentVariant = product.variants.find(function (v) { return v.id === currentId; }) || product.variants[0];
    var selectedOptions = {};

    product.options.forEach(function (name, idx) {
      selectedOptions[name] = currentVariant['option' + (idx + 1)];
    });

    function findVariant() {
      return product.variants.find(function (variant) {
        return product.options.every(function (name, idx) {
          return variant['option' + (idx + 1)] === selectedOptions[name];
        });
      });
    }

    var priceComingSoon = document.querySelector('[data-cp-price][data-price-coming-soon="true"]');
    var comingSoonLabel = (priceComingSoon && priceComingSoon.getAttribute('data-coming-soon-label')) || 'Coming Soon';

    function updateUI() {
      var variant = findVariant();
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      if (priceComingSoon) {
        if (priceEl) priceEl.textContent = comingSoonLabel;
      } else if (priceEl) {
        priceEl.textContent = formatMoney(variant.price).replace(/[A-Z]{3}\s?/, '$').replace(/^\$\$/, '$');
      }
      if (submitBtn) submitBtn.disabled = !variant.available;
      if (submitText) {
        if (!variant.available) {
          submitText.textContent = 'Sold out';
        } else if (priceComingSoon) {
          submitText.textContent = 'Add to Cart';
        } else {
          submitText.textContent = 'Add to Cart — ' + formatMoney(variant.price);
        }
      }
      if (inventoryEl && typeof variant.inventory_quantity === 'number') {
        inventoryEl.textContent = String(variant.inventory_quantity);
      }
    }

    form.querySelectorAll('[data-option-button]').forEach(function (button) {
      button.addEventListener('click', function () {
        var name = button.dataset.optionName;
        selectedOptions[name] = button.dataset.optionValue;
        form.querySelectorAll('[data-option-button][data-option-name="' + name + '"]').forEach(function (el) {
          el.classList.toggle('is-selected', el === button);
        });
        var label = document.querySelector('[data-option-label="' + name.toLowerCase().replace(/\s+/g, '-') + '"]');
        if (label) label.textContent = button.dataset.optionValue;
        updateUI();
      });
    });

    updateUI();
  }

  function initTabs() {
    var root = document.querySelector('[data-cp-tabs]');
    if (!root) return;
    var tabs = Array.from(root.querySelectorAll('[data-cp-tab]'));
    var panels = Array.from(root.querySelectorAll('[data-cp-panel]'));
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.dataset.cpTab;
        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        panels.forEach(function (panel) {
          var active = panel.dataset.cpPanel === key;
          panel.classList.toggle('is-active', active);
          if (active) panel.removeAttribute('hidden');
          else panel.setAttribute('hidden', '');
        });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initGallery(document.querySelector('[data-cp-gallery]'));
    initCopyLink();
    initTabs();
    var form = document.querySelector('.commercial .cp-form');
    if (form) {
      initQuantity(form);
      initVariants(form);
    }
  });
})();
